class CartSummary extends HTMLElement {
  connectedCallback() {
    // CTA mirrors the cart icon: when "Cart icon behavior" is "open cart drawer",
    // the CTA opens the drawer by reusing the cart icon's own trigger so the
    // behavior is identical. Delegated because the CTA re-renders on cart updates.
    this.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-cart-summary-open]');
      if (!trigger) return;
      event.preventDefault();
      // Stop the click reaching <body>: drawer.open() registers an outside-click
      // close listener on body, which would otherwise instantly re-close it.
      event.stopPropagation();

      const iconButton = document.querySelector('cart-icon-bubble button');
      const drawer = document.querySelector('cart-drawer');
      if (iconButton) {
        iconButton.click();
      } else if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else {
        window.location.href = routes.cart_url;
      }
    });
  }

  /**
   * getSectionsToRender
   * @returns {Array} Sections to render
   */
  getSectionsToRender() {
    return [
      {
        id: 'cart-summary',
        selector: '[data-cart-summary-contents]',
      },
    ];
  }

  /**
   * renderContents
   * @param {Object} parsedState
   */
  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace = this.querySelector(section.selector);
      if (!elementToReplace || !parsedState.sections?.[section.id]) {
        return;
      }

      elementToReplace.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });
  }

  /**
   * getSectionInnerHTML
   * @param {String} html
   * @param {String} selector
   * @returns {String}
   */
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

if (!customElements.get('cart-summary')) {
  window.CartSummary = CartSummary;
  customElements.define('cart-summary', CartSummary);
}